/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Automation_Action_Code_LabelInputs */

const en_automation_action_code_label = /** @type {(inputs: Automation_Action_Code_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.code === "case_requirements_unsatisfied") return /** @type {LocalizedString} */ (`Step requirements not met`);
	if (i?.code === "assignee_not_found") return /** @type {LocalizedString} */ (`Assignee not found`);
	if (i?.code === "assignee_permission_denied") return /** @type {LocalizedString} */ (`Assignee cannot hold this task`);
	if (i?.code === "missing_argument") return /** @type {LocalizedString} */ (`A required value was unavailable`);
	if (i?.code === "depth_exceeded") return /** @type {LocalizedString} */ (`Automation chain too deep`);
	if (i?.code === "action_error") return /** @type {LocalizedString} */ (`Unexpected error`);
	if (i?.code === "created_task_unavailable") return /** @type {LocalizedString} */ (`Created task could not be loaded`);
	if (i?.code === "precondition_failed") return /** @type {LocalizedString} */ (`The case had already moved on`);
	if (i?.code === "email_disabled") return /** @type {LocalizedString} */ (`Email is off for this task`);
	if (i?.code === "assignee_changed") return /** @type {LocalizedString} */ (`The assignee changed before sending`);
	if (i?.code === "assignee_unavailable") return /** @type {LocalizedString} */ (`Assignee is disabled or has no email`);
	if (i?.code === "task_finalized") return /** @type {LocalizedString} */ (`The task was already closed`);
	if (i?.code === "task_unassigned") return /** @type {LocalizedString} */ (`The task had no assignee`);
	return /** @type {LocalizedString} */ (`${i?.code}`)
	
};

const pt_br2_automation_action_code_label = /** @type {(inputs: Automation_Action_Code_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.code === "case_requirements_unsatisfied") return /** @type {LocalizedString} */ (`Requisitos da etapa não atendidos`);
	if (i?.code === "assignee_not_found") return /** @type {LocalizedString} */ (`Responsável não encontrado`);
	if (i?.code === "assignee_permission_denied") return /** @type {LocalizedString} */ (`Responsável não pode receber esta tarefa`);
	if (i?.code === "missing_argument") return /** @type {LocalizedString} */ (`Um valor obrigatório não estava disponível`);
	if (i?.code === "depth_exceeded") return /** @type {LocalizedString} */ (`Cadeia de automação profunda demais`);
	if (i?.code === "action_error") return /** @type {LocalizedString} */ (`Erro inesperado`);
	if (i?.code === "created_task_unavailable") return /** @type {LocalizedString} */ (`A tarefa criada não pôde ser carregada`);
	if (i?.code === "precondition_failed") return /** @type {LocalizedString} */ (`O caso já havia avançado`);
	if (i?.code === "email_disabled") return /** @type {LocalizedString} */ (`E-mail desativado para esta atividade`);
	if (i?.code === "assignee_changed") return /** @type {LocalizedString} */ (`O responsável mudou antes do envio`);
	if (i?.code === "assignee_unavailable") return /** @type {LocalizedString} */ (`Responsável inativo ou sem e-mail`);
	if (i?.code === "task_finalized") return /** @type {LocalizedString} */ (`A tarefa já estava encerrada`);
	if (i?.code === "task_unassigned") return /** @type {LocalizedString} */ (`A tarefa não tinha responsável`);
	return /** @type {LocalizedString} */ (`${i?.code}`)
	
};

/**
* | code | output |
* | --- | --- |
* | "case_requirements_unsatisfied" | "Step requirements not met" |
* | "assignee_not_found" | "Assignee not found" |
* | "assignee_permission_denied" | "Assignee cannot hold this task" |
* | "missing_argument" | "A required value was unavailable" |
* | "depth_exceeded" | "Automation chain too deep" |
* | "action_error" | "Unexpected error" |
* | "created_task_unavailable" | "Created task could not be loaded" |
* | "precondition_failed" | "The case had already moved on" |
* | "email_disabled" | "Email is off for this task" |
* | "assignee_changed" | "The assignee changed before sending" |
* | "assignee_unavailable" | "Assignee is disabled or has no email" |
* | "task_finalized" | "The task was already closed" |
* | "task_unassigned" | "The task had no assignee" |
* | * | "{code}" |
*
* @param {Automation_Action_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_action_code_label = /** @type {((inputs: Automation_Action_Code_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_Code_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_code_label(inputs)
	return pt_br2_automation_action_code_label(inputs)
});